// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReactionsSummary_wrapper__-Jhoa","reaction":"ReactionsSummary_reaction__1UVHc","total":"ReactionsSummary_total__1FxBG"};